import api from './api';

export const cacIndexService = {
  async getLastAvailablePeriod(): Promise<string | null> {
    const response = await api.get<{ lastAvailablePeriod: string | null }>('/cac/last-period');
    return response.data.lastAvailablePeriod ?? null;
  },
};
